// TODO: Move somewhere reusable (Update: honestly I'm not sure we want to reuse code this old!)
export default function RoundCurrencyFilter($filter, $locale) {
  'ngInject';

  // get angular's number filter
  var numberFilter = $filter('number');
  var currencySymbol = $locale.NUMBER_FORMATS.CURRENCY_SYM;

  return function (amount, decimals) {
    var value = '';
    var roundToDecimalPlace = decimals || 0;

    if (amount == null) {
      amount = 0;
    }

    // return a rounded value to a specific decimal place
    // this will return a string since the number might contain commas
    amount = numberFilter(amount, roundToDecimalPlace);

    // display negative currency value as ($val) instead of -$val
    if (amount.charAt(0) == '-') {
      value = '(' + currencySymbol + amount.substr(1) + ')';
    } else {
      value = currencySymbol + amount;
    }

    return value;
  };
}
